import { Alert } from 'antd';
import { FC, PropsWithChildren } from 'react';

const { ErrorBoundary } = Alert;
const AntdErrorBoundary = ErrorBoundary as any;

export const ErrorBoundaryLayout: FC<PropsWithChildren> = ({ children }) => {
  return <AntdErrorBoundary>{ children }</AntdErrorBoundary>;
};
